import { useNavigate } from 'react-router';
// assets
import {
    SettingOutlined,
    TabletOutlined,
    LaptopOutlined,
} from '@ant-design/icons';
import { TableActionsTypes } from 'constants/TableActionsTypes';

export const manageAction = type => {
    return props => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;
        const navigate = useNavigate();
        const { id, row } = params;
        const value = !type
            ? 'Manage'
            : type === TableActionsTypes.ManageLaptop
            ? 'ManageLaptop'
            : 'ManageTablet';

        const label = !type
            ? 'Manage'
            : type === TableActionsTypes.ManageLaptop
            ? 'Laptop'
            : 'Tablet';

        const handleOnClick = () => {
            const patch = !type
                ? 'manage'
                : type === TableActionsTypes.ManageLaptop
                ? 'manage-laptop'
                : 'manage-tablet';
            navigate(
                `${patch}/${id}/?lat=${row.lat}&lon=${row.lon}&alt=${row.alt}`,
                {
                    state: JSON.stringify(row),
                },
            );
            onClick(value);
        };

        const icon = !type ? (
            <SettingOutlined />
        ) : type === TableActionsTypes.ManageLaptop ? (
            <LaptopOutlined style={{ fontSize: 16 }} />
        ) : (
            <TabletOutlined style={{ fontSize: 16 }} />
        );

        return (
            <MenuItem
                key={value}
                value={value}
                label={label}
                icon={icon}
                onClick={handleOnClick}
                {...restProps}
            >
                {label}
            </MenuItem>
        );
    };
};
